import { render, staticRenderFns } from "./TableQuestionLayout.vue?vue&type=template&id=d7311a50&scoped=true"
import script from "./TableQuestionLayout.vue?vue&type=script&lang=js"
export * from "./TableQuestionLayout.vue?vue&type=script&lang=js"
import style0 from "./TableQuestionLayout.vue?vue&type=style&index=0&id=d7311a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7311a50",
  null
  
)

export default component.exports